// "Get to Know Me" student self-evaluation structure. Sections map to Social &
// Emotional CASEL domains so self-ratings can be compared with teacher ratings.

export const SELFEVAL_SECTIONS = [
  {
    key: "understanding_myself", emoji: "😊", title: "Understanding Myself", domain: "self_awareness",
    items: [
      { key: "tell_feelings", label: "Tell people how I am feeling" },
      { key: "understand_why", label: "Understand why I feel that way" },
      { key: "know_good_at", label: "Know what I am good at" },
      { key: "know_difficult", label: "Know what I find difficult" },
      { key: "learn_mistakes", label: "Learn from my mistakes" },
    ],
  },
  {
    key: "managing_feelings", emoji: "🎯", title: "Managing My Feelings", domain: "self_regulation",
    items: [
      { key: "stay_calm", label: "Stay calm when something goes wrong" },
      { key: "wait_turn", label: "Wait my turn" },
      { key: "keep_trying", label: "Keep trying when work is difficult" },
      { key: "calm_upset", label: "Calm myself when I feel upset" },
      { key: "cope_changes", label: "Cope with changes to my routine" },
    ],
  },
  {
    key: "understanding_others", emoji: "🤝", title: "Understanding Other People", domain: "social_awareness",
    items: [
      { key: "notice_feelings", label: "Notice when someone is happy or sad" },
      { key: "think_others", label: "Think about how other people feel" },
      { key: "include_others", label: "Include others" },
      { key: "kind_respectful", label: "Be kind and respectful" },
      { key: "help_others", label: "Help someone who needs it" },
    ],
  },
  {
    key: "working_playing", emoji: "💬", title: "Working and Playing with Others", domain: "relationship_skills",
    items: [
      { key: "listen", label: "Listen when others are speaking" },
      { key: "share_take_turns", label: "Share and take turns" },
      { key: "work_team", label: "Work well in a team" },
      { key: "solve_words", label: "Solve problems with words" },
      { key: "good_friend", label: "Be a good friend" },
    ],
  },
  {
    key: "good_choices", emoji: "⚖️", title: "Making Good Choices", domain: "responsible_decision_making",
    items: [
      { key: "think_before", label: "Think before I act" },
      { key: "safe_choices", label: "Make safe choices" },
      { key: "say_sorry", label: "Say sorry when I make a mistake" },
      { key: "ask_help", label: "Ask for help when I need it" },
      { key: "good_decisions", label: "Try to make good decisions" },
    ],
  },
];

export const CALM_OPTIONS = [
  { key: "someone_talks", label: "Someone talks to me" },
  { key: "quiet_time", label: "I have some quiet time" },
  { key: "move", label: "I move around" },
  { key: "deep_breaths", label: "I take deep breaths" },
  { key: "draw", label: "I draw or colour" },
  { key: "music", label: "I listen to music" },
  { key: "explain_again", label: "Someone explains things again" },
];

export const FAVOURITE_FIELDS = [
  { key: "subject", label: "Favourite subject" },
  { key: "activity", label: "Favourite activity" },
  { key: "game", label: "Favourite game/sport" },
  { key: "place", label: "Favourite place in school" },
  { key: "smile", label: "Something that makes me smile" },
];

export const RATING_HINT = { 1: "Not like me yet", 5: "Sometimes like me", 9: "Very much like me" };

export function sectionAverage(ratings, section) {
  const vals = section.items.map((it) => ratings?.[it.key]).filter((v) => v);
  if (!vals.length) return null;
  return Math.round((vals.reduce((a, b) => a + b, 0) / vals.length) * 10) / 10;
}

export function ratingColour(v) {
  if (!v) return "#cbd5e1";
  if (v <= 3) return "#C97064";
  if (v <= 6) return "#E0B341";
  return "#5d8a73";
}
